<template>
  <div>
    <div v-for="(item) in clueList" :key="item.id">
      <baseWBItem :report='item' v-if="item.category==5" />
      <baseItem v-else :type='2' :report='item' />
    </div>
  </div>
</template>

<script>
import baseItem from "@components/base-clue-Item";
import baseWBItem from "@components/base-WB-clue-Item";
export default {
  props: {
    clueList: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {};
  },
  components: {
    baseItem,
    baseWBItem
  }
};
</script>

<style>
</style>
